import { httpRequest } from "../../http";
import { LoginInfoSerializer } from "../../../models/serializers/loginInfoSerializer.ts";

export class CmdLoginMfaGoogle {

    async run(loginChallenge: string, idToken: string) {
        const params = {
            "login_challenge": loginChallenge,
            "id_token": idToken,
        };

        const response = await httpRequest<any>(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/login/mfa/google/`,
            {
                method: "POST",
                body: params,
                auth: false,
            },
        );

        const serializer = new LoginInfoSerializer();
        return serializer.deserialize(response);
    }
}
